import type { MouseEventHandler } from 'react'

import clsx from 'clsx'

import './style.scss'

import { StackIcon } from 'shared/ui'

export function Tag({
	onClick,
	text,
	type = 'small'
}: {
	onClick?: MouseEventHandler<HTMLElement>
	text: string
	type: 'big' | 'small'
}) {
	return (
		<div
			className={clsx('tag', {
				tag_big: type === 'big',
				tag_small: type === 'small'
			})}
			onClick={onClick}
		>
			<StackIcon
				className='tag__close-icon'
				icon='close'
				label='close'
				stroke='currentcolor'
				width={9}
			/>

			<div className='tag__text'>{text}</div>
		</div>
	)
}

export default Tag
